import React from "react";
import { styled } from "styled-components";

import { UserIcon, WorkspaceIcon } from "../../components/icons/CustomIcons";
import { Flex, HexAnchorButton, Txt } from "../../hex-components";
import { useMeQuery } from "../../route/HexRoutes.generated";
import { Routes } from "../../route/routes";

import { getCurrentUrl } from "./util";

export const CliAuthWorkspaceSelect = React.memo(
  function CliAuthWorkspaceSelect() {
    const { data: meData } = useMeQuery();

    if (!meData?.myOrg) return null;
    return (
      <TagFlex align="stretch" direction="column" gap={4} justify="between">
        <Flex gap={4} justify="between">
          <Flex gap={4}>
            <UserIcon />
            <Txt>{meData.me?.email}</Txt>
          </Flex>

          <HexAnchorButton
            extraSmall={true}
            href={Routes.ORG_SELECTOR.getUrl({
              queryParams: { redirectTo: getCurrentUrl() },
            })}
            minimal={true}
            subtle={true}
          >
            Change workspace
          </HexAnchorButton>
        </Flex>
        <Flex gap={4}>
          <WorkspaceIcon />
          <Txt>{meData.myOrg.displayName}</Txt>
        </Flex>
      </TagFlex>
    );
  },
);

const TagFlex = styled(Flex)`
  gap: 4px;
  padding: 8px;
  border-radius: ${({ theme }) => theme.borderRadius};
  background-color: ${({ theme }) => theme.backgroundColor.MUTED};
  border: 1px solid ${({ theme }) => theme.borderColor.MUTED};
`;
